import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDone({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.948 18.999l-.107-.012-.128-.029a.983.983 0 01-.192-.08l-.106-.067-.023-.017a1.032 1.032 0 01-.1-.087l-.044-.047-4.029-5.035a1 1 0 011.477-1.343l.085.093 3.301 4.127 11.21-11.21a1 1 0 011.32-.082l.095.083a1 1 0 01.083 1.32l-.083.094L8.675 18.738l-.086.07-.072.048a.98.98 0 01-.333.127l-.125.015h-.118.007z"
        fill={color}
      />
    </svg>
  )
}

export default SvgDone
